export const OrdersConstants = {
    GET_ORDERS_FACET_REQUEST: 'ORDERS/GET_ORDERS_FACET_REQUEST',
    GET_ORDERS_FACET_SUCCESS: 'ORDERS/GET_ORDERS_FACET_SUCCESS',
    GET_ORDERS_FACET_ERROR: 'ORDERS/GET_ORDERS_FACET_ERROR',
    GET_ORDERS_TABS_COUNT_REQUEST: 'ORDERS/GET_ORDERS_TABS_COUNT_REQUEST',
    GET_ORDERS_TABS_COUNT_SUCCESS: 'ORDERS/GET_ORDERS_TABS_COUNT_SUCCESS',
    GET_ORDERS_TABS_COUNT_ERROR: 'ORDERS/GET_ORDERS_TABS_COUNT_ERROR',
    GET_ORDERS_SLA_FACET_REQUEST: 'ORDERS/GET_ORDERS_SLA_FACET_REQUEST',
    GET_ORDERS_SLA_FACET_SUCCESS: 'ORDERS/GET_ORDERS_SLA_FACET_SUCCESS',
    GET_ORDERS_SLA_FACET_ERROR: 'ORDERS/GET_ORDERS_SLA_FACET_ERROR',
    APPLIED_FILTERS_ORDERS: 'ORDERS/APPLIED_FILTERS_ORDERS',
    APPLIED_MULTIPLE_FILTERS_ORDERS: 'ORDERS/APPLIED_MULTIPLE_FILTERS_ORDERS',
    APPLIED_TAGS_ORDERS: 'ORDERS/APPLIED_TAGS_ORDERS',
    CLEAR_APPLIED_FILTER_ORDERS: 'ORDERS/CLEAR_APPLIED_FILTER_ORDERS',
    CLEAR_APPLIED_TAGS_ORDERS: 'ORDERS/CLEAR_APPLIED_TAGS_ORDERS',
    APPLIED_STORE_FILTER: 'ORDERS/APPLIED_STORE_FILTER',
    ON_UPDATE_SELECTED_TAB: 'ORDERS/ON_UPDATE_SELECTED_TAB',
    UPDATE_DATE_RANGE: 'ORDERS/UPDATE_DATE_RANGE',
    ON_CHANGE_PAGINATION: 'ORDERS/ON_CHANGE_PAGINATION'
};
